import React from 'react';
import PaymentSwitch from './PaymentSwitch';
import UKPayeesContainer from '../../uk/main/containers/UKPayeeContainer';
import InternationalPayeesContainer from '../../international/InternationalPayeesContainer';

interface MakePaymentProps {
    active: boolean;
    ukClick: () => void;
    intClick: () => void;
}

const MakePayment = ({ active, ukClick, intClick }: MakePaymentProps) => {
    return (
        <div className="make-payment">
            <PaymentSwitch
                active={active}
                ukClick={ukClick}
                intClick={intClick}
            />
            {!active ? <UKPayeesContainer /> : <InternationalPayeesContainer />}
        </div>
    );
};

export default MakePayment;
